import "../../styles/employeeDetails.css";
import "../../styles/Calendar.css";

// import liabaries

import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import avatar from '../../assets/images/avatar.webp'
// import other internal components
import Calendar from "react-calendar";

// Icons from image gallery
import empIcon from "../../assets/images/emp-icon.png";
import dateIcon from "../../assets/images/joiningdate.png";
import calendarIcon from "../../assets/images/calendar.png";
import useEmployeeLeaveHistoryStore from "../../store/useEmployeeLeaveHistoryStore";
import useEmployeeDataByIdStore from "../../store/useEmployeeDataByIdStore";

const EmployeeLeaveHistoryTable = () => {
  const accessToken = localStorage.getItem("accessToken");
  const { id } = useParams();
  const { employeeDataPerId, fetchEmployeeDataPerId } =
    useEmployeeDataByIdStore();
  const { leaveHistory, fetchLeaveHistory } = useEmployeeLeaveHistoryStore();

  const navigate = useNavigate();

  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [view, setView] = useState(false);
  const [setMinDate] = useState(null);
  const [sortOrder, setSortOrder] = useState({
    apply_date: "asc",
    leave_from: "asc",
    leave_to: "asc",
    days_count: "asc",
    leaveType: "asc",
    is_approved: "asc",
  });
  const [sortedLeaveHistory, setSortedLeaveHistory] = useState([]);

  const startDateOnChange = (startDate) => {
    setSelectedStartDate(startDate);
    setMinDate(startDate);
  };

  const endDateOnChange = (endDate) => {
    setSelectedEndDate(endDate);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    fetchEmployeeDataPerId(id, accessToken);
    fetchLeaveHistory(id, accessToken);
  }, [id]);

  const clearAllDates = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  };

  const searchButtonClick = async () => {
    const formattedStartDate = formatDate(selectedStartDate);
    const formattedEndDate = formatDate(selectedEndDate);

    await fetchLeaveHistory(
      id,
      accessToken,
      formattedStartDate,
      formattedEndDate,
    );

    setView(false);
  };

  const handleSort = (columnName) => {
    const currentOrder = sortOrder[columnName];
    const newOrder = currentOrder === "asc" ? "desc" : "asc";

    const sortedData = [...leaveHistory].sort((a, b) => {
      if (columnName === "days_count" || columnName === "is_approved") {
        if (newOrder === "asc") {
          return a[columnName] - b[columnName];
        } else {
          return b[columnName] - a[columnName];
        }
      } else {
        if (newOrder === "asc") {
          return a[columnName].localeCompare(b[columnName]);
        } else {
          return b[columnName].localeCompare(a[columnName]);
        }
      }
    });

    setSortOrder({ ...sortOrder, [columnName]: newOrder });
    setSortedLeaveHistory(sortedData);
  };

  return (
    <div className="w-full px-4 py-10">
      <div className="mb-6">
        <div className="flex items-center gap-5">
          <button
            onClick={() => navigate("/leavemanagement")}
            className="flex items-center gap-1 text-[22px] font-medium text-green-600 hover:opacity-80"
          >
            <i className="ri-arrow-left-s-line"></i>
            BACK
          </button>

          <h4 className="text-2xl font-medium text-[#505050] mb-0">
            Employee Leave History
          </h4>
        </div>
      </div>
      {employeeDataPerId.map((employee) => (
        <div className="grid grid-cols-3 gap-2 mb-8">
          <div className="w-[300px] h-[140px] bg-white flex items-center justify-center gap-3 rounded-lg shadow-sm ">
            <div className="border border-blue-700 p-1 rounded-full">
              <img
                src={employee?.users?.profile_picture || avatar}
                alt="employee"
                className="w-[50px] h-[50px] rounded-full object-cover"
              />
            </div>
            <div>
              <h1 className="text-base font-medium text-gray-700">
                {employee?.employee_full_name}
              </h1>
              <p className="text-sm text-gray-400">
                {employee?.users?.roles[0]?.role_name}
              </p>
            </div>
          </div>

          <div className="w-[300px] h-[140px] bg-white flex items-center justify-center border-l border-r rounded-lg shadow-sm">
            <div className="flex items-center">
              <div>
                <img src={empIcon} alt="icon" className="mr-3" />
              </div>
              <div>
                <h6 className="text-sm text-gray-400 mb-0">Employee ID</h6>
                <p className="text-base font-medium text-gray-700 mb-0">
                  {employee?.users?.employee_id}
                </p>
              </div>
            </div>
          </div>
          <div className="w-[300px] h-[140px] bg-white flex items-center justify-center rounded-lg shadow-sm">
            <div className="flex items-center gap-2">
              <div>
                <img src={dateIcon} alt="icon" />
              </div>
              <div>
                <h6 className="text-sm text-gray-400 mb-0">Joining Date</h6>
                <p className="text-base font-medium text-gray-700 mb-0">
                  {employee.joining_date}
                </p>
              </div>
            </div>
          </div>
        </div>
      ))}
      <div className="relative flex items-start justify-between bg-white rounded-lg px-8 py-3 shadow-sm mb-1">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-5 text-sm cursor-pointer">
            <div>
              {!selectedStartDate && !selectedEndDate && (
                <p style={{ margin: 0 }}>Select Dates</p>
              )}
            </div>
            <div>
              <img
                src={calendarIcon}
                alt="icon"
                onClick={() => setView(!view)}
              />
            </div>
            <div>
              {selectedStartDate && selectedEndDate && (
                <p style={{ margin: 0 }}>Selected Dates</p>
              )}
            </div>
          </div>
          {view && (
            <div className="absolute top-full left-0 mt-2 bg-white border border-gray-200 rounded-lg shadow-xl p-4 z-50">
              <div className="flex gap-4">
                <div>
                  <Calendar
                    onChange={startDateOnChange}
                    value={selectedStartDate}
                  />
                </div>
                <div>
                  <Calendar
                    onChange={endDateOnChange}
                    value={selectedEndDate}
                    minDate={selectedStartDate}
                  />
                </div>
              </div>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  className="w-24 h-8 rounded-md border border-gray-300 text-sm font-medium hover:bg-gray-50"
                  onClick={clearAllDates}
                >
                  Clear All
                </button>
                <button
                  className="w-24 h-8 rounded-md bg-[var(--secondary-color)] text-white text-sm font-medium hover:opacity-90"
                  onClick={searchButtonClick}
                >
                  Search
                </button>
              </div>
            </div>
          )}

          {selectedStartDate && selectedEndDate && (
            <div className="selected_dates" style={{ fontSize: "14px" }}>
              {selectedStartDate.toLocaleDateString()} -{" "}
              {selectedEndDate.toLocaleDateString()}
            </div>
          )}
        </div>
      </div>

      <div className="attendance__table">
        <table className="table">
          <thead>
            <tr>
              <th>SL No.</th>

              <th onClick={() => handleSort("apply_date")}>
                Applied Date {sortOrder["apply_date"] === "asc" ? "↑" : "↓"}
              </th>
              <th onClick={() => handleSort("leave_from")}>
                Leave Start Date {sortOrder["leave_from"] === "asc" ? "↑" : "↓"}
              </th>
              <th onClick={() => handleSort("leave_to")}>
                Leave End Date {sortOrder["leave_to"] === "asc" ? "↑" : "↓"}
              </th>
              <th onClick={() => handleSort("days_count")}>
                No Of Days {sortOrder["days_count"] === "asc" ? "↑" : "↓"}
              </th>
              <th onClick={() => handleSort("leaveType")}>
                Leave Type {sortOrder["leaveType"] === "asc" ? "↑" : "↓"}
              </th>
              <th onClick={() => handleSort("is_approved")}>
                Status {sortOrder["is_approved"] === "asc" ? "↑" : "↓"}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedLeaveHistory.map((leave, index) => (
              <tr>
                <td>{index + 1}</td>

                <td>{leave.apply_date}</td>
                <td>{leave.leave_from}</td>
                <td>{leave.leave_to}</td>
                <td>{leave.days_count}</td>
                <td>{leave.leaveType}</td>
                <td>
                  {leave.is_approved === 1 && (
                    <span className="approved">Approved</span>
                  )}
                  {leave.is_approved === 0 && (
                    <span className="rejected">Declined</span>
                  )}
                  {leave.is_approved === null && (
                    <span className="pending">Pending</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EmployeeLeaveHistoryTable;
